<ng-container *ngIf="canUseInnerWalls; else noInnerWallsAllowed">
  <div *ngIf="!!openingQuestion">
    <p>
      {{ 'STEPINNERWALL.OPENINGTEXT' | translate }}
    </p>
    <div class="question">{{ 'STEPINNERWALL.DOYOUWANT' | translate }}</div>
    <app-isomasters-button (modularClick)="hideOpeningQuestion()">
      <div description>{{ 'YES' | translate }}</div>
    </app-isomasters-button>
    <app-isomasters-button (modularClick)="nextStep()">
      <div description>{{ 'NO' | translate }}</div>
    </app-isomasters-button>
  </div>
  <ng-container *ngIf="!openingQuestion">
    <div *ngIf="!selectedWall">
      <div class="no-wall-background">
        <div class="nowall-icon">
          <img height="100" src="/assets/svg/icon-geendeuren.svg" />
        </div>
        <div class="instruction-text">
          <div class="text bold">{{ 'STEPINNERWALL.INTRODUCTIONTEXTNOSELECTIONTITLE' | translate }}</div>
          <div class="text">{{ 'STEPINNERWALL.INTRODUCTIONTEXTNOSELECTIONDESCRIPTION' | translate }}</div>
        </div>
      </div>
    </div>
    <div *ngIf="!!selectedWall && selectedWallIsInner">
      <p>
        {{ 'STEPINNERWALL.INTRODUCTIONTEXTINNERWALLSELECTED' | translate }}
      </p>
      <div class="selected-wall">
        <div class="wall-space">
          <div class="wall-image">
            <img [src]="getInnerWallImage(selectedWall?.innerWall?.type)" class="wall-picture" height="57" />
          </div>
          <div class="wall-type-text">
            {{ 'INNERWALL.' + innerWallTypes[selectedWall?.innerWall?.type] | uppercase | translate }}
          </div>
        </div>
        <div (click)="removeWall()" class="delete-wall">
          <div [inlineSVG]="'assets/svg/icon-trash.svg'" class="icon"></div>
        </div>
      </div>
      <div class="title">
        {{ 'STEPINNERWALL.ONWALL' | translate }}:
        {{ 'WALL.' + selectedWall?.innerWall?.placedOnSide | translate }}
      </div>
      <div class="title">{{ 'STEPINNERWALL.POSITION' | translate }}</div>
      <app-step-five-slider
        #slider
        (newPositionFromLeft$)="newLeftPosition($event)"
        [collided$]="collided$"></app-step-five-slider>
    </div>
    <div *ngIf="!!selectedWall && !selectedWallIsInner">
      <p>
        {{ 'STEPINNERWALL.INTRODUCTIONTEXTADDINNERWALL' | translate }}
      </p>
      <div *ngIf="showInnerWallOption(innerWallTypes.lProfile)" class="inner-wall-option">
        <app-isomasters-button
          (modularClick)="addInnerWall(innerWallTypes.lProfile)"
          [selected]="false"
          [style.height.px]="80"
          [style.padding-right.px]="24"
          [style.width.px]="80"
          class="wall">
          <div content>
            <img [src]="getInnerWallImage(innerWallTypes.lProfile)" class="wall-picture" height="57" />
          </div>
        </app-isomasters-button>
        <div class="description">{{ 'INNERWALL.LPROFILE' | translate }}</div>
        <div (click)="addInnerWall(innerWallTypes.lProfile)" class="plus">
          <div class="icon">
            <div class="horizontal"></div>
            <div class="vertical"></div>
          </div>
        </div>
      </div>
      <div
        *ngIf="showInnerWallOption(innerWallTypes.threeway)"
        [class.disabled]="!canUseThreeway"
        class="inner-wall-option">
        <app-isomasters-button
          (modularClick)="addInnerWall(innerWallTypes.threeway)"
          [selected]="false"
          [style.height.px]="80"
          [style.padding-right.px]="24"
          [style.width.px]="80"
          class="wall">
          <div content>
            <img [src]="getInnerWallImage(innerWallTypes.threeway)" class="wall-picture" height="57" />
          </div>
        </app-isomasters-button>
        <div class="description">{{ 'INNERWALL.THREEWAY' | translate }}</div>
        <div (click)="addInnerWall(innerWallTypes.threeway)" class="plus">
          <div class="icon">
            <div class="horizontal"></div>
            <div class="vertical"></div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #noInnerWallsAllowed>
  <p>
    {{ 'STEPINNERWALL.NO_INNER_WALL_AT_THIS_THICKNESS' | translate }}
  </p>
</ng-template>
